// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {PostModuleLayout} from 'app_components/modules/admin/post'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PostService from 'app_services/admin/post/postService'
import ReactSelectService from 'app_services/components/reactSelectService'
// @end

// @import types
// @end

// @ADD Component types
interface IPostModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
}
interface IPostModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class PostModule extends Component<IPostModuleProps, IPostModuleState> {

  private postService: PostService
  private reactSelectService: ReactSelectService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IPostModuleProps) {
    super(props)
    this.state = {}

    this.postService = new PostService()
    this.reactSelectService = new ReactSelectService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onSubmit = async (data: any) => {
    if (data.postType) data.postType = this.reactSelectService.formatReactSelectResponse(data.postType)
    if (data.tags) data.tags = this.reactSelectService.formatReactSelectResponse(data.tags)
    if (data.tags === "") delete data.tags
    if (data.locations) data.locations = this.reactSelectService.formatReactSelectResponse(data.locations)
    if (data.platform_video) data.platform_video = this.reactSelectService.formatReactSelectResponse(data.platform_video)
    if (!data.content) data.content = {}
    if (data.authors) data.authors = this.reactSelectService.formatReactSelectResponse(data.authors)
    if (data.authors === "") delete data.authors
    if (data.highlighted === "") delete data.highlighted

    const postResponse = await this.postService.insertOrUpdate(
      data,
      (this.props.editData && this.props.editData._id) ? `update/${this.props.editData._id}` : 'create'
    )

    if (postResponse) {
      let screen_notification_label = 'components.screen_notifications.add'
      if (this.props.editData && this.props.editData._id) {
        screen_notification_label = 'components.screen_notifications.update'
      }

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(postResponse)
      }
    }

    this.setState({ status: null })
  }

  render() {
    return(
      <PostModuleLayout
        {...this.props}
        onHandleSubmit={this.onSubmit}
        viewer={this.props.viewer}
      />
    )
  }
}

export default connect(mapStatesToProps)(PostModule)
